import { Component } from '@angular/core';
import { TableModule } from 'primeng/table';
import { OrdenCompraService } from '../../services/api/orden-compra.service';
import { Customer } from '../../models/customer';

@Component({
  selector: 'app-tabla-paginada',
  standalone: true,
  imports: [TableModule],
  templateUrl: './tabla-paginada.component.html',
  styleUrl: './tabla-paginada.component.css',
})
export class TablaPaginadaComponent {
  customers!: Customer[];

  constructor(private ordenCompraService: OrdenCompraService) {}

  ngOnInit() {
    this.ordenCompraService
      .getDummy()
      .then((customers: Customer[]) => (this.customers = customers));
  }
}
